import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#080812] flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-[#AAFF00] border-t-transparent rounded-full animate-spin" />
          <span className="text-sm text-[#FAFAF8]/50">Loading...</span>
        </div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/auth" replace />;
  }

  if (user && !user.onboarded) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
